export { default as MapWidget } from "./map_widget_container";
import * as MapWidgetFactory from "./map_widget_factory";
export { default as WidgetEditMap } from "./map_widget_form";
export { MapWidgetFactory };
